import logo from "../assets/carryvilly_logo.png"
import { Link } from 'react-router-dom';

function Navigation({userObj, isLoggedIn}){   
    return (
        <nav className="navbar navbar-expand-lg navbar-dark fixed-top" id="mainNav">
            <div className="container">
                <Link className="navbar-brand" to={process.env.PUBLIC_URL + "/"} style={{ textDecoration: 'none' }}>
                    <img src={logo} alt="carryvilly" />&nbsp;carryvilly
                </Link>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarResponsive"
                    aria-controls="navbarResponsive"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                Menu
                <i className="fas fa-bars ms-1"></i>
                </button>
                <div className="collapse navbar-collapse" id="navbarResponsive">
                    <ul className="navbar-nav text-uppercase ms-auto py-4 py-lg-0">
                        <li className="nav-item" id='home'>
                            <Link to={process.env.PUBLIC_URL + "/"} className="nav-link">
                                Home
                            </Link>
                        </li>
                        <li className="nav-item" id='products' onClick={() => {localStorage.removeItem("selectedValue");localStorage.removeItem("currentPage");}}>
                            <Link className="nav-link" to={process.env.PUBLIC_URL + "/products"}>
                                Products   
                            </Link>
                        </li>
                        <li className="nav-item" id='review'>
                            <Link className="nav-link" to={process.env.PUBLIC_URL + "/review"}>
                            Review   
                            </Link>
                        </li>
                        <li className="nav-item" id='about'>
                            <Link className="nav-link" to={process.env.PUBLIC_URL + "/about"}>About</Link>
                        </li>
                        {function(){
                            if(isLoggedIn){
                                if(userObj.email === "carryvilly@gmail.com"){
                                    return (
                                        <li className="nav-item" onClick={() => {localStorage.removeItem("selectedValue");localStorage.removeItem("currentPage");}}>
                                            <Link className="nav-link" to={process.env.PUBLIC_URL + "/account"}>Admin</Link>
                                        </li>
                                    );
                                } else {
                                    return (
                                        <li className="nav-item">
                                            <Link className="nav-link" to={process.env.PUBLIC_URL + "/account"}>Profile</Link>
                                        </li>
                                    );
                                }
                            } else {
                                return (
                                    <li className="nav-item">
                                        <Link className="nav-link" to={process.env.PUBLIC_URL + "/account"} style={{ textDecoration: 'none' }}>Sign In</Link>
                                    </li>
                                )
                            }
                            }()
                        }    
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default Navigation;